import { formatProductsForGoogleAnalytics } from './formatProductsForGoogleAnalytics';

class Analytics {
  items(items) {
    if (items) {
      this.google_items = formatProductsForGoogleAnalytics(items);
    }

    return this;
  }

  beginCheckout() {
    if (typeof gtag === 'function' && this.google_items) {
      gtag('event', 'begin_checkout', {
        items: this.google_items
      });
    }
  }

  checkoutProgress(step) {
    if (typeof gtag === 'function' && this.google_items) {
      gtag('event', 'checkout_progress', {
        checkout_step: step,
        items: this.google_items
      });
    }
  }

  completePurchase(order_number, total, tax, shipping) {
    if (typeof gtag === 'function' && this.google_items) {
      gtag('event', 'purchase', {
        transaction_id: order_number,
        affiliation: 'FRP',
        value: total,
        currency: 'USD',
        tax: tax,
        shipping: shipping,
        items: this.google_items,
      });
    }
    if (window.uetq) {
      window.uetq.push('event', 'purchase', {
        'event_category': 'checkout', 
        'revenue_value': total, 
        'currency': 'USD',
      });
    }
  }
}

export default new Analytics;